import type {TypographyProps} from '@mui/material/Typography';

export const getEmphasizedFontWeight = (variant: TypographyProps['variant']) => {
    return variant === 'micro' ? '700' : '500';
};
